import http from 'hub-http/clients/apiClient';
export const API_PATH_V2 = 'hubdb/api/v2/tables';
export const CONNECTED_PAGES_API_PATH = 'cms/v3/hubdb/content-editor';
function fetchPublishedTables() {
  return http.get(API_PATH_V2, {
    query: {
      limit: 1000
    }
  });
}
export function fetchAllRows(tableId, query = {}) {
  return http.get(`${API_PATH_V2}/${tableId}/rows/draft`, {
    query
  });
}
export function fetchRow(tableId, rowId) {
  return http.get(`${API_PATH_V2}/${tableId}/rows/${rowId}/draft`);
}
export function fetchRowModuleSchema(tableName) {
  return http.get(`${CONNECTED_PAGES_API_PATH}/tables/${tableName}/module`);
}
export function fetchAllTables(params = {
  limit: 1000
}) {
  return http.get(`${API_PATH_V2}/search/draft`, {
    query: params
  });
}
export default {
  fetchPublishedTables,
  fetchAllTables,
  fetchAllRows,
  fetchRowModuleSchema
};